module.exports = __webpack_public_path__ + "img/works_kuraray_miniapp_1.69ae6cb1.png";